import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import {QueryClient,QueryClientProvider} from '@tanstack/react-query'
import { useAlertContext } from './context/Alerts';
import { JobDetailsContextProvider } from './context/Job_details';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { UserProvider } from './context/User';
import { ErrHandleProvider } from './context/Err_handle';
import { useBaseUrlContext } from './context/Base_url';

import {ThemeProvider, CssBaseline  } from '@mui/material';
import {ThemeMain, ThemeCustom} from './styles/Theme'
import './styles/style.scss'

import SignIn from './views/Sign_in';
import JobBoard from './views/Job_board';
import CreateJob from './views/Create_job';
import UploadCv from './views/Upload_cv';
import NavBar from './components/navbar/Nav_bar';
import Review from './views/Review';
import UnAssignedCv from './views/Unassigned_cv';
import Dashboard from './views/Dashboard';
import EmailAutomation from './views/Email_automation';
import NotFound from './views/404'

const queryClient = new QueryClient()

const App = () => {

  const [navBar, setNavBar] = useState(false)
  const location = useLocation();
  const { baseUrl } = useBaseUrlContext();
  const { sucessAlert, failAlert } = useAlertContext();


  //location change 

  useEffect(() => {
    
    switch (location.pathname) {
      case '/':
        setNavBar(false);  
      break;
      case '/job-board':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/dashboard':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/create-job':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/upload-cv':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/review':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/unlinked-cvs':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      case '/email-automation':
        setNavBar(true); 
        document.body.className = 'body-bg-cultured'
      break;
      default:
        setNavBar(false); 
        document.body.className = 'body-bg-cultured'
        break;
    }

    if(location.pathname.includes('/upload-cv/') || location.pathname.includes('/review/')){
      setNavBar(true); 
      document.body.className = 'body-bg-cultured'
    }

    
  },[location])

  return (
    <UserProvider>
    <ErrHandleProvider>
    <JobDetailsContextProvider> 
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={ThemeMain}>
        <CssBaseline enableColorScheme/>
          {
            navBar && <NavBar/>
          }
          <Routes>
            <Route path='/' element={<SignIn/>} />
            <Route path='/job-board' element={<JobBoard/>} />
            <Route path='/dashboard' element={<Dashboard/>} />
            <Route path='/create-job' element={<CreateJob/>} />
            <Route path='/upload-cv/:id' element={<UploadCv/>} />
            <Route path='/review/:id' element={<Review/>} />
            <Route path='/unlinked-cvs' element={<UnAssignedCv/>} />
            <Route path='/email-automation' element={<EmailAutomation/>} />
            <Route path='*' element={<NotFound/>} />
          </Routes>  
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>  
    </JobDetailsContextProvider>   
    </ErrHandleProvider>
    </UserProvider>
  );
}

export default App;
